var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingBase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 6.10749C35.4133 6.10749 43.8925 14.5765 43.8925 25C43.8925 35.4235 35.4235 43.8925 25 43.8925C14.5765 43.8925 6.10749 35.4133 6.10749 25C6.10749 14.5867 14.5765 6.10749 25 6.10749ZM25 0C11.1869 0 0 11.1869 0 25C0 38.8131 11.1869 50 25 50C38.8131 50 50 38.8131 50 25C50 11.1869 38.8029 0 25 0Z",
    fill: "#DDEFFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingBase);
export default __webpack_public_path__ + "static/media/loading_base.fedb1b9b27bffdc74dc6e5be6ea9ed05.svg";
export { ForwardRef as ReactComponent };